import { Appointment, TaskListItem, TechnicianAppointmentsItem, TimeManagementListItem } from '@myapp/contract'
import { TechnicianInfo } from './TechnicianInfo'
import { WeekCell } from './WeekCell'
import { resolveBreakForDay } from '../../../entities/time-entry/model/useBreakBlock'
import { isWorkingDay } from '../../../shared/lib/timeline/weekHelpers'

interface Props {
  item: TechnicianAppointmentsItem
  weekDays: string[]
  appointmentsByDay: Map<string, Appointment[]>
  timeManagementByDay: Map<string, TimeManagementListItem[]>
  tasksByDay?: Map<string, TaskListItem[]>
  onDayClick: (dayIso: string) => void
  onTimeManagementClick?: (id: number) => void
  onTaskClick?: (taskId: number) => void
}

export const WeekTechnicianRow = ({ item, weekDays, appointmentsByDay, timeManagementByDay, tasksByDay, onDayClick, onTimeManagementClick, onTaskClick }: Props) => (
  <div className="w-full flex items-stretch">
    <TechnicianInfo
      technicianId={item.technicianId}
      technicianName={item.technicianName}
      technicianRoles={item.technicianRoles}
      technicianAvatar={item.technicianAvatar}
    />
    <div className="flex-1 grid grid-cols-5 min-w-0">
      {weekDays.map((dayKey) => {
        const dayIso = new Date(dayKey + 'T00:00:00').toISOString()
        const working = isWorkingDay(item.workingDays, dayIso)
        const breakInfo = working ? resolveBreakForDay(item, dayIso) : null

        return (
          <WeekCell
            key={dayKey}
            appointments={appointmentsByDay.get(dayKey) ?? []}
            breakStartIso={breakInfo?.startTimeIso}
            timeManagementEntries={timeManagementByDay.get(dayKey)}
            tasks={tasksByDay?.get(dayKey)}
            isWorkingDay={working}
            onClick={() => onDayClick(dayKey)}
            onTimeManagementClick={onTimeManagementClick}
            onTaskClick={onTaskClick}
          />
        )
      })}
    </div>
  </div>
)
